import {html, LitElement} from 'lit';
import {classMap} from 'lit/directives/class-map.js';
import styles from './x-card.component.scss?as=stylesheet';
import {defineCustomElement} from 'extensions/utils';

export class Card extends LitElement {
	static styles = [styles];

	static get properties () {
		return {
			type: {
				type: String
			}
		};
	}

	constructor () {
		super();

		/**
		 * @type {'card'|'product'}
		 */
		this.type = 'card';
	}

	render () {
		const rootClasses = {
			[`type--${this.type}`]: true,
			card: true
		};

		return html`
			<div class="${classMap(rootClasses)}">
				<slot></slot>
			</div>
		`;
	}
};

defineCustomElement('x-card', Card);
